import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';

import {AppRoutingModule} from './app-routing.module';
import {NewsWidgetModule} from './shared/news-widget/news-widget.module';
import { SwiperDemoModule } from './swiper-demo/swiper-demo.module';
import { FormWizardModule } from 'angular2-wizard';
import {HeaderComponent} from './shared/header/header.component';
import {FooterComponent} from './shared/footer/footer.component';
//import {TopNavComponent} from './shared/top-navigation/top-navigation.component';
import {TopNavModule} from './shared/top-navigation/top-navigation.module';
import {NavbarModule} from './shared/navigation/navbar.module';
//import {NavbarComponent} from './shared/navigation/navbar.component';
import {AuthService} from './shared/auth/auth.service';
import {AuthenticatedGuard} from './shared/guards/authenticated.guard';
import {UnauthenticatedGuard} from './shared/guards/unauthenticated.guard';
import {HomeComponent} from './home/home.component';
// import {FeaturedHomeComponent} from './featured-home/featured-home.component';
// import {FeaturedHomeService} from './featured-home/featured-home.service';
import {FeaturedHomeModule} from './featured-home/featured-home.module';
import {FBPostsModule} from './facebook-posts/fb-posts.module';
//import { IRewardsModule } from './irewards/irewards.module';
import {BannersModule} from './banners/banners.module'
import { PerfectScrollbarModule } from 'angular2-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'angular2-perfect-scrollbar';
import {CategoriesListModule} from './category-list/category-list.module';
import {LandingPageModule} from './landing-page/landing-page.module';
import { CompanyComponent } from './company/company.component';
import { CompanyService } from './company/company.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AutoEnrolComponent } from './auto_enrol/auto-enrol.component';

//import { UpdateSqModalComponent } from './update-sq-modal/update-sq-modal.component';

 const PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
   suppressScrollX: true
 };

@NgModule({
  declarations: [
    AppComponent, HeaderComponent ,HomeComponent,FooterComponent,CompanyComponent,AutoEnrolComponent //, NavbarComponent, //,FeaturedHomeComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    AppRoutingModule,
   SwiperDemoModule,
    FeaturedHomeModule,
    BannersModule,
    NewsWidgetModule,
    FBPostsModule,
    FormWizardModule,
    CategoriesListModule,
    NavbarModule,
    TopNavModule,
    LandingPageModule,
    PerfectScrollbarModule.forRoot(PERFECT_SCROLLBAR_CONFIG),
    NgxSpinnerModule
    
  ],
  providers: [AuthService, AuthenticatedGuard,
        UnauthenticatedGuard,CompanyService,
        { provide: LOCALE_ID, useValue: "en-AU" }
        //,FeaturedHomeService
        ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts